import 'intersection-observer'
import * as React from 'react'
import { InView } from 'react-intersection-observer'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { blockInviewHandler } from '../../../drupal/rendering/inview_utils.mod'
import { CMSState } from '../../../publicSite/drupalPage/state'
import { getClassName } from '../utils.gen'
import { Media } from '../utils/media.mod'

export type IframeBlockProps = {
  index: number
  link: string
  useCookieBar: boolean
  cookiePlaceholder?: JSX.Element | string
  cookieButton?: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type IframeBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  iframe_classname: string
}>

export function IframeBlock(
  props: IframeBlockProps,
  options?: { style?: IframeBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX((onDone) => (
      <InView
        as="section"
        onChange={(inView) =>
          blockInviewHandler(
            'iframe',
            inView,
            `io-${options && options.key ? options.key : props.index}`,
            getClassName(options, 'inview_classname', 'inview')
          )
        }
        triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
        threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
        id={`io-${options && options.key ? options.key : props.index}`}
        className={getClassName(options, 'block_classname', 'container')}
        key={options && options.key ? options.key : `block-${props.index}`}
      >
        <div className={getClassName(options, 'inner_classname', 'py-5')}>
          <div className={getClassName(options, 'content_classname', '')}>
            <div className={getClassName(options, 'iframe_classname', '')}>
              <Media kind="iframe" useCookiebar={props.useCookieBar} url={props.link} />
            </div>
          </div>
        </div>
      </InView>
    ))
}
